<template>
  <div class="page">
  <div style="text-align:center;margin-bottom: 10px;">
      <van-icon name="alipay" color="#1296db" size="60px"/>
      <div>
          <span>支付宝转账</span>
      </div>
  </div>

    <van-cell icon="qr" title="扫码转账" is-link @click="showQrImg"></van-cell>

    <van-field
      v-model="transforTradeNo"
      placeholder="填写交易号/订单号"
      left-icon="records"
    ></van-field>

    <van-button
      type="primary"
      style="width: 100%; margin-top:20px;"
      @click="apply"
      >验证</van-button
    >
    
    <van-row style="background-color: #ffffcc; border-left:solid #ffcc33 5px; margin-top: 20px; padding: 10px; font-size: 14px;">
      <van-col span="24">
        <b>温馨提示</b>
        <p>1. 点击扫码转账，截图保存；</p>
        <p>2. 打开支付宝扫一扫，选择截图保存的收款码，在转账页面输入加款金额；</p>
        <p>3. 在下方填写该笔转账交易的“交易号/订单号”点击验证；</p>
        <p>4. 加款验证将在5分钟内完成，如超过时间仍未到账，请联系官方客服：13145186519。</p>
        <p></p>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { Row, Col, Cell, Button, Field, Toast, Dialog, ImagePreview, Icon } from "vant";
import additionalApi from "@/api/additional";

export default {
  name: "AlipayTransfor",

  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Cell.name]: Cell,
    [Button.name]: Button,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    [ImagePreview.Component.name]: ImagePreview.Component,
    [Icon.name]: Icon,
  },

  data() {
    return {
      transforTradeNo: "",
    };
  },

  mounted() {
    // if(this.$store.state.user.user.state !== 1) {
    //   this.$router.push("/userValidate")
    // }
  },

  methods: {
    reset() {
      this.transforTradeNo = "";
    },
    apply() {
      let params = {
        userId: this.$store.state.user.user.id,
        type: "支付宝转账",
        transactionNo: this.transforTradeNo,
      };
      additionalApi.apply(params).then((res) => {
        if (res.success) {
          Toast.success('加款验证提交成功');
          this.reset();
        } else {
          Dialog({
            message: res.message,
            confirmButtonColor: "#1989fa",
          });
        }
      });
    },
    showQrImg(){
      // ImagePreview({images: ['code_alipay.jpg'], closeable: true})
    }
  },
};
</script>

<style scoped>
.page {
  padding: 0px 10px;
}
.maintain {
  width: 100px;
  text-align: center;
  margin: 200px auto;
  color: #999;
}
.tips {
  color: rgba(216, 8, 8, 0.685);
}
.btn-primary {
  margin: 20px 0px;
  width: 100%;
}
.van-cell {
  font-size: 16px;
}
</style>
